import CashierPreferencesHelper from './cashier-preferences-helper';

export const calculateHeight = (
  height: number,
  windowHeight: number = 768,
): { dimension: number; stringValue: string } => {
  return calculateDimension(height, windowHeight, 'height');
};

export const calculateWidth = (
  width: number,
  windowWidth: number = 1366,
): { dimension: number; stringValue: string } => {
  return calculateDimension(width, windowWidth, 'width');
};

export const calculateDimension = (
  dimension: number,
  windowDimension: number,
  direction: 'width' | 'height',
): { dimension: number; stringValue: string } => {
  const calculated: number = (dimension / windowDimension) * 100;
  let viewportUnit = '';
  switch (direction) {
    case 'height':
      viewportUnit = 'vh';
      break;
    case 'width':
      viewportUnit = 'vw';
      break;
  }
  const stringValue: string = `${calculated}${viewportUnit}`;

  return { dimension: calculated, stringValue: stringValue };
};

/*
 Default parentFontSize was taken from here: https://developer.mozilla.org/en-US/docs/Web/CSS/font-size
*/
export const em = (fontSize: number, parentFontSize: number = 16): string => {
  const cashierPrefFontScalar = CashierPreferencesHelper.textSizeScalar();
  const calculatedEmSize: number = (fontSize / parentFontSize) * cashierPrefFontScalar;

  return `${calculatedEmSize}em`;
};

export const rem = (fontSize: number): string => {
  return `${calculateFontSize(fontSize)}rem`;
};

export const vh = (fontSize: number): string => {
  return `${calculateFontSize(fontSize)}vh`;
};

export const vw = (fontSize: number): string => {
  return `${calculateFontSize(fontSize)}vw`;
};

export const px = (fontSize: number): string => {
  return `${calculateFontSize(fontSize)}px`;
};

const calculateFontSize = (fontSize: number): number => {
  if (CashierPreferencesHelper) {
    return fontSize * CashierPreferencesHelper.textSizeScalar();
  }
  return fontSize * 1;
};

export const typographyOverrides = () => ({
  typography: {
    h1: {},
    h2: {
      fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontSize: rem(2),
      fontWeight: 500,
      lineHeight: 1.25,
      letterSpacing: '0.2px',
    },
    h3: {
      fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontSize: rem(1.75),
      fontWeight: 500,
      lineHeight: 1.147,
    },

    h4: {
      fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      '@media (width: 1024px) and (height: 576px)': {
        fontSize: rem(1.25),
      },
      '@media (width: 1024px) and (height: 768px)': {
        fontSize: rem(1.25),
      },
      '@media (aspect-ratio: 4/3) (and height:768)': {
        fontSize: rem(1.2),
      },
      fontSize: rem(1.5),
      fontWeight: 500,
      lineHeight: 1.147,
      textAlign: 'center',
    },
    h5: {},
    h6: {
      fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontSize: rem(1.25),
      fontWeight: 500,
      letterSpacing: '.5px',
      lineHeight: 1.147,
      textAlign: 'center',
    },
    caption: {
      fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontSize: rem(0.75),
      fontWeight: 500,
      letterSpacing: '.5px',
      lineHeight: 1.25,
    },
    body1: {
      fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontSize: rem(1.125),
      fontWeight: 500,
      letterSpacing: '.4px',
      lineHeight: 1.357,
    },

    body2: {
      fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      '@media (width: 1600px) and (height: 1200px)': {
        fontSize: rem(1.25),
      },
      '@media (width: 1920px) and (height: 1080px)': {
        fontSize: rem(1.25),
      },
      fontSize: rem(0.875),
      fontWeight: 500,
      letterSpacing: '.25px',
      lineHeight: 1.125,
      textAlign: 'center',
    },

    subtitle1: {
      fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      '@media (max-width: 1024px)': {
        fontSize: rem(0.875),
      },
      '@media (width: 1600px) and (height: 1200px)': {
        fontSize: rem(1.2),
      },
      '@media (width: 1920px) and (height: 1080px)': {
        fontSize: rem(1.2),
      },
      fontSize: rem(1),
      fontWeight: 500,
      letterSpacing: '.15px',
      lineHeight: 1.11,
    },
    subtitle2: {},
  },
});
